import { chakra } from '@chakra-ui/system'
import Conversations from 'public/img/message_bubble_icon.svg'

export const ConversationsIcon = chakra(Conversations)
